export default __webpack_public_path__ + "static/media/ShoppingBagBlack.513062fd.svg";